import { FC, ReactElement } from "react";
import { Box, Card, Typography, Stack } from "@mui/material";

import DutiesChart from "./duties-chart";
import DutiesStackedBar from "./duties-stacked-bar";
import { formatNumberWithSuffix } from "@/utils";
import { responsiveFontSizes, spacing } from "@/utils/responsive";

const DutiesCard: FC<{
  data: { name: string; value: number }[];
  total: number;
  totalDutiesPaid: number;
}> = ({ data, total, totalDutiesPaid }): ReactElement => {
  return (
    <Card sx={{ 
      p: { xs: 1, md: 1.25 }, 
      height: "100%", 
      display: "flex", 
      flexDirection: "column" 
    }}>
      <Box mb={spacing.md}>
        <Stack direction="row" justifyContent="space-between" alignItems="flex-start">
          <Box>
            <Typography 
              color="neutral.500" 
              variant="body1" 
              fontWeight={500} 
              mb={spacing.sm}
            >
              Overall Duties
            </Typography>
            <Typography
              color="neutral.1000"
              fontFamily="Plus Jakarta Sans"
              fontWeight={700}
              variant="h2"
              sx={{
                fontSize: responsiveFontSizes['3xl'],
                lineHeight: 1.1,
              }}
            >
              ${formatNumberWithSuffix(total)}
            </Typography>
          </Box>
        </Stack>
        <Box mt={spacing.md}>
          <DutiesStackedBar dutiesPaid={totalDutiesPaid} dutiesDue={total} />
          <Stack direction="row" spacing={{ xs: 1.5, md: 2 }}>
            <Stack direction="row" spacing={1} alignItems="center">
              <Box sx={{ 
                width: { xs: 8, md: 10 }, 
                height: { xs: 8, md: 10 }, 
                bgcolor: "#10B981", 
                borderRadius: "2px" 
              }} />
              <Typography variant="caption" fontWeight={500}>Duties Paid</Typography>
              <Typography variant="caption" fontWeight={700}>
                ${formatNumberWithSuffix(totalDutiesPaid)}
              </Typography>
            </Stack>
            <Stack direction="row" spacing={1} alignItems="center">
              <Box sx={{ 
                width: { xs: 8, md: 10 }, 
                height: { xs: 8, md: 10 }, 
                bgcolor: "#E5E7EB", 
                borderRadius: "2px" 
              }} />
              <Typography variant="caption" fontWeight={500}>Duties Due</Typography>
              <Typography variant="caption" fontWeight={700}>
                ${formatNumberWithSuffix(total)}
              </Typography>
            </Stack>
          </Stack>
        </Box>
      </Box>
      <Box sx={{ flex: 1, display: "flex", flexDirection: "column", justifyContent: "center" }}>
        <DutiesChart data={data} />
      </Box>
    </Card>
  );
};

export default DutiesCard;
